<template>

<div>
  <b-container>
    <b-form-row>
      <b-col>
        <label class="d-block">Nombre y Apellidos
          <b-form-input type="text" v-model="user.name"/>
        </label>
      </b-col>
      <b-col>
        <label class="d-block">Correo Electrónico
          <b-form-input type="email" v-model="user.email"/>
        </label>
      </b-col>
      <b-col>
        <label class="d-block">Estado
          <b-form-select v-model="user.status" :options="statusOptions"/>
        </label>
      </b-col>
    </b-form-row>
    <b-form-row>
      <b-col>
        <label class="d-block">Contraseña
          <b-form-input type="password" v-model.trim="user.password" @change="$v.user.password.$touch()" :state="passwordState"/>
        </label>
      </b-col>
      <b-col>
        <label class="d-block">Repetir Contraseña
          <b-form-input type="password" v-model.trim="user.passwordConfirmation" @change="$v.user.passwordConfirmation.$touch()" :state="passwordConfirmationState"/>
        </label>
      </b-col>
    </b-form-row>
    <b-form-row>
      <b-col>
        <label class="d-block">Rol
          <b-form-select @change="changedAppUserType" v-model="user.appUserType" :options="appUserTypeOptions"/>
        </label>
      </b-col>
      <b-col cols="8">
        <label class="d-block">Permisos
          <multiselect v-model="selectedAuthorities" :options="authoritiesOptions" multiple label="label" track-by="value"
                       placeholder="Seleccionar Permisos" selectLabel="Seleccionar" selectedLabel="Seleccionado" deselectLabel="Eliminar"/>
        </label>
      </b-col>
    </b-form-row>
  </b-container>
</div>

</template>

<script>

import {sameAs, minLength} from 'vuelidate/lib/validators'

export default {
  name: 'UserForm',
  model: {prop: 'user'},
  props: {
    user: {type: Object, required: true}
  },
  data() {
    return {
      statusOptions: [
        {text: 'Activado', value: 'ACTIVATED'},
        {text: 'Desactivado', value: 'DEACTIVATED'}
      ],
      appUserTypeOptions: [
        {text: 'Operario', value: 'EMPLOYEE'},
        {text: 'Gestor', value: 'MANAGER'},
        {text: 'Administrador', value: 'ADMINISTRATOR'}
      ],
      authoritiesOptions: [
        {label: 'Admin', value: 'ROLE_ADMIN'},
        {label: 'Clientes: Crear', value: 'ROLE_CLIENT_CREATE'},
        {label: 'Clientes: Editar', value: 'ROLE_CLIENT_UPDATE'},
        {label: 'Clientes: Ver', value: 'ROLE_CLIENT_SELECT'},
        {label: 'Clientes: Eliminar', value: 'ROLE_CLIENT_DELETE'},
        {label: 'Partes: Crear', value: 'ROLE_WORK_ORDER_CREATE'},
        {label: 'Partes: Validar', value: 'ROLE_ADMINISTRATIVE_VALIDATION'},
        {label: 'Partes: Histórico', value: 'ROLE_WORK_ORDER_HISTORY'},
        {label: 'Partes: Cambiar Estado', value: 'ROLE_WORK_ORDER_EDIT_STATUS'},
        {label: 'Partes: Cambiar Proyecto', value: 'ROLE_WORK_ORDER_CHANGE_PROJECT'},
        {label: 'Partes: Eliminar', value: 'ROLE_WORK_ORDER_DELETE'},
        {label: 'Proyectos: Crear', value: 'ROLE_PROJECT_CREATE'},
        {label: 'Proyectos: Editar', value: 'ROLE_PROJECT_UPDATE'},
        {label: 'Proyectos: Ver', value: 'ROLE_PROJECT_SELECT'},
        {label: 'Proyectos: Eliminar', value: 'ROLE_PROJECT_DELETE'},
        {label: 'Usuarios: Crear', value: 'ROLE_USER_CREATE'},
        {label: 'Usuarios: Editar', value: 'ROLE_USER_UPDATE'},
        {label: 'Usuarios: Ver', value: 'ROLE_USER_SELECT'},
        {label: 'Usuarios: Eliminar', value: 'ROLE_USER_DELETE'},
        {label: 'Registro laboral: Ver', value: 'ROLE_TIME_RECORD'}
      ],
      selectedAuthorities: []
    }
  },
  computed: {
    passwordState() {
      if (!this.$v.user.password.$dirty) {
        return null
      }
      return !this.$v.user.password.$invalid
    },
    passwordConfirmationState() {
      if (!this.$v.user.passwordConfirmation.$dirty) {
        return null
      }
      return !this.$v.user.passwordConfirmation.$invalid
    },
    invalid() {
      return this.$v.$anyDirty && this.$v.$invalid
    }
  },
  validations: {
    user: {
      password: {
        minLength: minLength(8)
      },
      passwordConfirmation: {
        minLength: minLength(8),
        sameAsPassword: sameAs('password')
      }
    }
  },
  methods: {
    resetValidation() {
      this.$v.$reset()
    },
    changedAppUserType(userType) {
      const authorities = this.getDefaultAuthorities(userType)
      this.selectedAuthorities = this.authoritiesOptions.filter(i => authorities.includes(i.value))
    },
    getDefaultAuthorities(userType) {
      switch (userType) {
        case 'EMPLOYEE':
          return ['ROLE_WORK_ORDER_CREATE', 'ROLE_PROJECT_SELECT', 'ROLE_CLIENT_SELECT', 'ROLE_USER_SELECT']
        case 'MANAGER':
          return ['ROLE_PROJECT_SELECT', 'ROLE_CLIENT_SELECT', 'ROLE_USER_SELECT', 'ROLE_WORK_ORDER_HISTORY', 'ROLE_WORK_ORDER_CREATE']
        case 'ADMINISTRATOR':
          return this.authoritiesOptions.map(i => i.value) // all of them
        default:
          return []
      }
    }
  },
  watch: {
    user(value) {
      if (value.authorities) {
        this.selectedAuthorities = value.authorities.map(i => this.authoritiesOptions.find(j => j.value === i))
      }
    },
    selectedAuthorities(value) {
      this.user.authorities = value.map(i => i.value)
    }
  }
}

</script>



// WEBPACK FOOTER //
// src/components/user/UserForm.vue